import { createFileRoute } from "@tanstack/react-router";
import JeugdHusselavondOrganiseren from "@/pages/JeugdHusselavondOrganiseren";

export const Route = createFileRoute("/jeugd-husselavond-organiseren")({
  head: () => ({
    meta: [
      { title: "Jeugd-husselavond organiseren — kindvriendelijk husselen | De Hussel App" },
      { name: "description", content: "Husselavond voor de jeugd op je tennisclub? Veilige indelingen op niveau, korte rondes en aanmelden via ouders. Zo houd je kinderen aan het tennissen." },
      { property: "og:title", content: "Jeugd-husselavond organiseren — kindvriendelijk husselen | De Hussel App" },
      { property: "og:description", content: "Husselavond voor de jeugd op je tennisclub? Veilige indelingen op niveau, korte rondes en aanmelden via ouders. Zo houd je kinderen aan het tennissen." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://dehusselapp.nl/jeugd-husselavond-organiseren" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://dehusselapp.nl/jeugd-husselavond-organiseren" }],
  }),
  component: JeugdHusselavondOrganiseren,
});
